<template>
  <div class="content if-profile px-4">
    <div class="md-layout if-profile-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <nav aria-label="breadcrumb" role="navigation">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'ContactUs' }">
                Contact us
              </router-link>
            </li>
          </ol>
        </nav>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <!-- <div class="md-layout page-wrapper">
          <div class="md-layout-item privacy-policy md-size-100">
            <h1 class="md-display-3">Ways to Communicate</h1>
          </div>
        </div> -->
        <h1 class="section_header m-0">Ways to Communicate</h1>
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-size-100 get_touch p-0">
            <md-card class="if_card">
              <md-card-header>Get In Touch</md-card-header>
              <md-card-content>
                <div class="md-layout p-4">
                  <div class="md-layout-item md-size-33">
                    <h3>Address:</h3>
                    <p><md-icon>location_on</md-icon>172 Main St, Suite 100 Metuchen, NJ 08840</p>
                  </div>
                  <div class="md-layout-item md-size-33">
                    <h3>Office Hours:</h3>
                    <p><md-icon>watch_later</md-icon><span>Monday to Friday</span>8:30-5:00 Eastern Time</p>
                  </div>
                  <div class="md-layout-item md-size-33">
                    <h3>Call Us:</h3>
                    <p><md-icon>phone_in_talk</md-icon><a href="tel:7179096000">(717) 909-6000</a></p>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-medium-size-100 md-size-100 contact-form p-0">
            <md-card class="welcome-card-wrap if_card">
              <md-card-header>
                Contact us by phone, mail, or email. We will not distribute or sell your information.
              </md-card-header>
              <md-card-content>
                <!-- <div class="contact-form d-flex md-alignment-y-center"> -->
                  <div class="md-layout form ">
                    <!-- <h5 class="md-display-1">
                      Contact us by phone, mail, or email. We will not distribute or
                      sell your information.
                    </h5> -->
                    <div class="md-layout-item md-size-100 px-4 mt-4">
                      <div class="md-layout d-flex">
                        <div class="md-layout-item">
                          <label for="">First Name:</label>
                          <md-field class="input">
                            <md-input
                              class="form-imput"
                              placeholder="First Name"
                            ></md-input>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <label for="">Last Name:</label>
                          <md-field class="input">
                            <md-input
                              class="form-imput"
                              placeholder="Last Name"
                            ></md-input>
                          </md-field>
                        </div>
                      </div>
                      <div class="md-layout">
                        <div class="md-layout-item">
                          <label for="">E-mail:</label>
                          <md-field class="input">
                            <md-input
                              id="email"
                              class="form-imput"
                              type="email"
                              placeholder="E-Mail Address"
                            ></md-input>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <label for="">Phone:</label>
                          <md-field class="input form-imput">
                            <md-input
                              id="phone"
                              class="form-imput"
                              type="text"
                              placeholder="Phone number"
                            ></md-input>
                          </md-field>
                        </div>
                        <div class="md-layout-item md-size-100">
                          <label for="">Message:</label>
                          <md-field class="text-area">
                            <md-textarea
                              class="message"
                              v-model="autogrow"
                              md-autogrow
                              placeholder="Message"
                            ></md-textarea>
                          </md-field>
                        </div>
                        <div class="md-layout md-size-100 checkbox-box">
                          <div class="md-layout-item form-checkbox md-size-75">
                            <md-checkbox
                              v-model="withSetValue"
                              true-value="true"
                              false-value="false"
                            ></md-checkbox>
                            <div class="title">Add me to the Bizminer mailing list</div>
                          </div>
                          <div class="md-layout-item md-size-25">
                            <md-button class="submit md-round">Submit</md-button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="md-layout-item md-size-30">
                      <h2><strong>(717) 909-6000</strong></h2>
                    </div> -->
                  </div>
                <!-- </div> -->
              </md-card-content>
            </md-card>
          </div>
          <!-- <div class="md-layout page-wrapper">
            <div class="md-layout contact-us-addres">
              <div class="md-layout-item md-size-50 addres-body">
                <div class="card-icon-right card-help-icon">
                  <md-icon>location_on</md-icon>
                </div>
                <h1 class="md-title">Address:</h1>
                <p>
                  172 Main St, Suite 100 <br />
                  Metuchen, NJ 08840
                </p>
              </div>
              <div class="md-layout-item md-size-50 addres-body">
                <div class="card-icon-right card-help-icon">
                  <md-icon>watch_later</md-icon>
                </div>
                <h1 class="md-title">Office Hours:</h1>
                <p>
                  Monday to Friday <br />
                  8:30-5 Eastern Time
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ContactUs',
  data: () => ({
    withSetValue: null,
    autogrow: '',
  }),
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
};
</script>

<style lang="scss">
.get_touch{
  .if_card{
    .md-card-header{
      background: #133a64;
      color: #fff;
      border-radius: 0;
    }
  }
  .md-layout-item:not(:last-of-type){
    border-right: 1px solid rgba(0,0,0,0.2);
  }
  h3{
    font-size: 17px;
    line-height: 20px;
    font-weight: 600;
    color: #133a64;
    margin: 10px 0 0;
    text-transform: uppercase;
  }
  p{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: #666;
    font-size: 14px !important;
    line-height: 20px;
    font-weight: 500 !important;
    .md-icon{
      color: #133a64 !important;
      font-size: 22px !important;
      margin: 0 5px 0 0;
    }
    span{
      padding: 0 15px;
      background: #666;
      color: #fff;
      font-size: 11px;
      line-height: 20px;
      display: inline-block;
      border-radius: 10px;
      margin-right: 5px;
    }
  }
}
.contact-form {
  width: 100%;
  .if_card{
    .md-card-header{
      background: #133a64;
      color: #fff;
      border-radius: 0;
    }
  }
  .form {
    h5 {
      font-size: 18px;
      font-weight: 500;
      color: #3c4858;
      width: 100%;
      color: #3c4858;
      display: flex;
      justify-content: center;
      margin: 45px 0 !important;
    }
    h2 {
      font-size: 28px;
      color: #3b7ef1;
      margin-bottom: 20px;
      line-height: 40px;
      margin: 0;
    }
  }
  label{
    font-size: 13px;
    line-height: 16px;
    color: #133a64;
    font-weight: 600;
  }
  .input {
    caret-color: black;
    padding: 3px 12px 3px 12px;
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid #d5dae2;
    height: 40px;
    margin: 0 0 16px 0;
    box-shadow: inset 0 0px 0px rgb(0 0 0 / 8%);
    align-items: center;

    .form-imput {
      font-weight: 400;
    }
  }

  .text-area {
    margin: 0px 0 10px 0px;
    height: 76px;
    width: 100%;
    background-color: #fff;
    border-radius: 2px;
    border: 1px solid #d5dae2;
    padding: 10px 15px;
    box-shadow: inset 0 0px 0px rgb(0 0 0 / 8%);
    .message {
      font-weight: 300;
    }
  }

  .submit {
    background-color: #3b7ef1 !important;
    color: #fff !important;
    padding: 0 10px;
    float: right;
    display: block;
    margin-top: 14px;
    font-size: 15px;
    line-height: 17px;
    font-weight: 400;
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
      box-shadow: 0 14px 26px -12px rgb(59 126 241 / 42%),
        0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(59 126 241 / 20%);
      background-color: #2d75f0 !important;
    }
  }

  .checkbox-box {
    justify-content: flex-end;
    .form-checkbox {
      display: flex;
      align-items: center;
      margin-bottom: 25px !important;
      .md-checkbox{
        margin-right: 10px;
      }
      .title {
        font-size: 14px;
        margin-bottom: 0;
        font-weight: 500;
      }
    }
  }
  .md-field:after {
    height: 0px;
  }
  .md-field:before {
    height: 0px;
  }
}

.header-filter::before {
  background: white;
}

.contact-us-addres {
  margin-top: 40px;
  .addres-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    h1 {
      font-size: 20px !important;
      color: #3c4858;
      letter-spacing: 0.25px;
      font-weight: 300;
      margin-bottom: 0;
    }
  }
}
</style>
